import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCalendar } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule, Router } from '@angular/router';
import { TimeFormatPipe } from '../../../../core/shared/pipes/time-format.pipe';
import { MentorAvailabilityComponent } from '../mentor-availability/mentor-availability.component';
import { AuthService } from '../../../../core/services/auth.service';
import { UsersService } from '../../../../core/services/users.service';
import { USER_TYPES } from '../../../../core/shared/constants';
import { LoaderService } from '../../../../core/shared/services/loader.service';

@Component({
  selector: 'app-users-assigned-table',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, MatIconModule, MatNativeDateModule],
  templateUrl: './users-assigned-table.component.html',
  styleUrl: './users-assigned-table.component.scss'
})
export class UsersAssignedTableComponent implements OnInit {
  private authService = inject(AuthService);
  private authUser = this.authService.getAuthUser();
  private loader = inject(LoaderService);
  private usersService = inject(UsersService); // Asumiendo que tienes un servicio para manejar usuarios
  private router = inject(Router);
  assignedUsers: any[] = [];
  filteredUsers: any[] = [];
  searchQuery: string = '';
  activeTab: string = 'todos';
  sortOrder: string = 'fecha-ingreso';
  lastActivity: any[] = [];

  ngOnInit(): void {
    this.loadAssignedUsers();
    this.loadActivity();
  }

  loadAssignedUsers(): void {
    this.loader.show();

    this.usersService.findCustomersByCoach(this.authUser!.id, this.searchQuery).subscribe({
      next: (response) => {
        if (response && response.data) {
          this.assignedUsers = response.data;
          this.filteredUsers = this.assignedUsers;
        }
        this.loader.hide();

      },
      error: (error) => {
        console.error('Error al cargar tests:', error);
        this.loader.hide();
      }
    });

  }
  loadActivity(): void {
    this.lastActivity = [
      { date: '2023-10-01', activity: 'Ikigai desbloqueado' },
      { date: '2023-10-02', activity: 'Ikigai desbloqueado' },
    ]
  }

  filterUsers(): void {
    // this.filteredUsers = [...this.assignedUsers];
    this.filteredUsers = this.assignedUsers;
    // console.log('Filtrando usuarios:', this.filteredUsers);  

    // Filtrar por tab
    if (this.activeTab === 'nuevos') {
      console.log('Filtrando usuarios nuevos');
      // Aquí podrías implementar un filtro de usuarios nuevos
      // Por ejemplo, filtrar usuarios con menos de 7 días en la plataforma
      const daysAgo = new Date();
      daysAgo.setDate(daysAgo.getDate() - 1);
      this.filteredUsers = this.assignedUsers.filter(user => new Date(user.createdAt) >= daysAgo);
      
    }

    // Ordenar
    if (this.sortOrder === 'fecha-ingreso') {
      // Ordenar por fecha de ingreso (simulado)
      console.log('Ordenando por fecha de ingreso');
      this.filteredUsers.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
    } else if (this.sortOrder === 'nombre') {
      this.filteredUsers.sort((a, b) => a.name.localeCompare(b.name));
    } else if (this.sortOrder === 'ultima-actividad') {
      // Ordenar por última actividad (simulado)
    }
  }

  changeTab(tab: string): void {
    this.activeTab = tab;
    this.filterUsers();
  }

  viewUser(user: any) {
    this.router.navigate(['dashboard/users-assigned', user._id]);
  }

}
